import Currency from '@/dto/deliveries/Currency'
import { InitialResponse } from './ShipmentService'
import Delivery from '@/dto/deliveries/Delivery'

export interface Currencies {
  [key: string]: Currency
}

export interface DeliveryTypes {
  [key: string]: string
}

export interface MeasureUnits {
  [key: string]: string
}

export interface CalculatorTypes {
  [key: string]: string
}

export interface CalculatorTypesGroups {
  [key: string]: string[]
}

export interface DeliveredDuties {
  [key: string]: string[]
}

class DictionariesService {
  public currencies: Currencies = {}
  public calculatorTypes: CalculatorTypes = {}
  public calculatorTypesGroups: CalculatorTypesGroups = {}
  public allowedDeliveredDuties: DeliveredDuties = {}
  public deliveryTypes: DeliveryTypes = {}
  public measureUnits: MeasureUnits = {}
  public tabsMap: any = {}

  public load(response: InitialResponse): void {
    this.currencies = response.currencies
    this.calculatorTypes = response.calculatorTypes
    this.calculatorTypesGroups = response.calculatorTypesGroups
    this.deliveryTypes = response.deliveryTypes
    this.measureUnits = response.measureUnits
    this.allowedDeliveredDuties = response.deliveredDuties
    this.tabsMap = response.tabsMap
  }

  public getDeliveryTypeLabel(deliveryType: string) {
    return this.deliveryTypes[deliveryType]
  }

  public getCalculatorTypeLabel(calculatorType: string) {
    return this.calculatorTypes[calculatorType]
  }

  public getDeliveryTypesOptions() {
    const entries = Object.entries(this.deliveryTypes)

    const options = entries.map(([type, label]) => ({
      label,
      value: type,
    }))

    options.unshift({ label: 'Не выбран', value: '' })

    return options
  }

  public getCurrenciesOptions() {
    const entries = Object.entries(this.currencies)

    return entries.map(([type, currency]: [string, Currency]) => ({
      label: currency.display_name,
      value: type,
      symbol: currency.symbol,
    }))
  }

  public getDefaultWightUnit(): string {
    return Object.keys(this.measureUnits)[0]
  }

  public getCurrenciesForCalculator(): Currency[] {
    return [this.currencies.RUB, this.currencies.EUR]
  }

  getTabsForDelivery(delivery: Delivery): string[] | null {
    const { type, calculatorType, deliveryPointType } = delivery

    if (!type || !calculatorType || !this.tabsMap[type]) {
      return null
    }

    const tabsForDeliveryType = this.tabsMap[type]
    const tabsForCalculatorType = tabsForDeliveryType[calculatorType]

    if (!tabsForCalculatorType) {
      return null
    }

    if (calculatorType === 'DELIVERY_POINT') {
      if (deliveryPointType) {
        const tabs = tabsForCalculatorType[deliveryPointType]

        return tabs || null
      }

      return null
    }

    return tabsForCalculatorType || null
  }
}

export default new DictionariesService()
